import { useEffect, useState } from "react";
//---------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import Sketch from "src/components/common/sketch";
import { useMyStore } from "src/components/main/mainStore";
import { arrayReducer, myAxios, MyFormData, MyDate, isDevMode } from "src/components/common/functions";
//---------------------------------------------------------
export default function ManholeForm({
    form, closeIt, /*items, */
    setWorkLogs, 
    // workLog
    workLogHashKey, 
    userName
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // form: content, form, hashKey, signId, sketchesId, id
    const [picData, setPicData] = useState([]);
    const [sketches, setSketches] = useState([]);
    const itemsPre = [
        {title: "Manhole No."}, 
        {title: "Cancel", default: "No"}, 
        {title: "Coordniates", type: "latlng"}, 
        {title: "Type"},
        {title: "Material Type"},
        {title: "Location"},
        {title: "Depth to Bottom"},
        {title: "inverts", default: 0}
    ]
    const invertsTitles = Array.from({length: (form.content?JSON.parse(form.content).inverts:0) || 0}, (v, i) => ([
        {title: `Invert ${i + 1} Size`},
        {title: `Invert ${i + 1} Size NA`, default: false},
        {title: `Invert ${i + 1} Depth`},
        {title: `Invert ${i + 1} Depth NA`, default: false},
        {title: `Invert ${i + 1} Direction`},
        {title: `Invert ${i + 1} topBottom`},
        
    ])).reduce(arrayReducer, []);
    const itemsPost = [
        {title: "Swing Tie 1"}, 
        {title: "Swing Tie 2"}, 
        {title: "Swing Tie 3"}, 
        {title: "Notes", type: "textarea"}
    ]
    const items = [...itemsPre, ...invertsTitles,...itemsPost];

    //---------------------------------------------------------
    const formContent = JSON.parse(
        form.content?
        JSON.stringify(Object.fromEntries([
        ...items.map(f => 
            (() => {
                const key = f.title;
                const value = JSON.parse(form.content)[f.title];
                if(key === "Depth to Bottom"){
                    return [key, value?.slice(0, -7)];
                }else if(
                    key.slice(0, 7) === "Invert " && 
                    key.slice(-10) === " topBottom"
                ){
                    const depthValue = JSON.parse(form.content)[key.replace("topBottom", "Depth")];
                    if(depthValue === "Unavailable") return [key, ""];
                    const topBottomEntry = [key];
                    if(depthValue?.includes("to bottom")) topBottomEntry.push("to bottom");
                    if(depthValue?.includes("to top")) topBottomEntry.push("to top");
                    return topBottomEntry;
                }else if(
                    key.slice(0, 7) === "Invert " && 
                    key.slice(-6) === " Depth"
                ){
                    if(value === "Unavailable") return [key, ""];
                    return [key, value?.split(" ")[2]];
                }else if(
                    key.slice(0, 7) === "Invert " && 
                    key.slice(-9) === " Depth NA"
                ){
                    const sizeNA = JSON.parse(form.content)[key.replace("Depth NA", "Depth")] === "Unavailable";
                    return [key, sizeNA];
                }else if(
                    key.slice(0, 7) === "Invert " && 
                    key.slice(-5) === " Size"
                ){
                    if(value === "Unavailable") return [key, ""];
                    return [key, value?.slice(0, -7)];
                }else if(
                    key.slice(0, 7) === "Invert " && 
                    key.slice(-8) === " Size NA"
                ){
                    const sizeNA = JSON.parse(form.content)[key.replace("Size NA", "Size")] === "Unavailable";
                    return [key, sizeNA];
                }else{
                    return [key, value];
                }
            })()
        ),
        (items.some(i => i.type === "latlng")?
        ["latitude", JSON.parse(form.content).latitude || ""]:null),
        (items.some(i => i.type === "latlng")?
        ["longitude", JSON.parse(form.content).longitude || ""]:null)
        ]))
        :
        JSON.stringify(Object.fromEntries(
        items.map(f => [f.title, f.default === undefined?"":f.default])))
    );
    const [itemChecked, setItemChecked] = useState(formContent);
    const [showSketch, setShowSketch] = useState(false);
    //---------------------------------------------------------
    const handleFormSubmit = async e => {
        const curInvertsTitles = Array.from({length: itemChecked.inverts}, (v, i) => ([
            {title: `Invert ${i + 1} Size`, value: !itemChecked[`Invert ${i + 1} Size NA`]?itemChecked[`Invert ${i + 1} Size`] + " inches":"Unavailable"},
            {title: `Invert ${i + 1} Depth`, value: !itemChecked[`Invert ${i + 1} Depth NA`]?"(" + itemChecked[`Invert ${i + 1} topBottom`] + ") " + itemChecked[`Invert ${i + 1} Depth`] + " inches":"Unavailable"},
            {title: `Invert ${i + 1} Direction`},
        ])).reduce(arrayReducer, []);
        const items = [...itemsPre,{title: "Depth to Bottom", value: itemChecked["Depth to Bottom"] + " inches"}, ...curInvertsTitles,...itemsPost];
        const curFormContent = JSON.parse(
            JSON.stringify(Object.fromEntries([
            ...items.map(f => [f.title, f.value || itemChecked[f.title]]),
                (items.some(i => i.type === "latlng")?
                ["latitude", itemChecked.latitude || ""]:null),
                (items.some(i => i.type === "latlng")?
                ["longitude", itemChecked.longitude || ""]:null)
            ]))
        );
        e.preventDefault();
        if(!picData.length){
            window.alert("Please sign!");
            return; 
        }
        
        const formData = new MyFormData(e.currentTarget);
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:""
        }))));
        formData.append("submitTime", (new MyDate()).ss());
        formData.append("signData", JSON.stringify(picData));
        formData.append("sign", document.getElementById("esign").toDataURL());
        formData.append("data", JSON.stringify(curFormContent));
        formData.append("title", form.form.toUpperCase());
        formData.append("form", "preChecklist");
        formData.append("formHashKey", form.hashKey);
        formData.append("cancel", itemChecked.Cancel);
        const docNum = itemChecked["Manhole No."]?itemChecked["Manhole No."]:"";
        formData.append("docNum", docNum);
        formData.append("forms", "yes");
        formData.append("formContent", JSON.stringify(itemChecked));
        //---------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("workLogs/forms.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, workLogFiles:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data[0]:
                w.workLogFiles
            ), forms:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data[1]:
                w.forms
            )
        })));
        closeIt();
    }
    const handleFormSave = async () => {
        const curInvertsTitles = Array.from({length: itemChecked.inverts}, (v, i) => ([
            {title: `Invert ${i + 1} Size`, value: itemChecked[`Invert ${i + 1} Size`] + " inches"},
            {title: `Invert ${i + 1} Depth`, value: "(" + itemChecked[`Invert ${i + 1} topBottom`] + ") " + itemChecked[`Invert ${i + 1} Depth`] + " inches"},
            {title: `Invert ${i + 1} Direction`},
        ])).reduce(arrayReducer, []);
        const items = [...itemsPre,{title: "Depth to Bottom", value: itemChecked["Depth to Bottom"] + " inches"}, ...curInvertsTitles,...itemsPost];
        const curFormContent = JSON.parse(
            JSON.stringify(Object.fromEntries([
            ...items.map(f => [f.title, f.value || itemChecked[f.title]]),
            (items.some(i => i.type === "latlng")?
            ["latitude", itemChecked.latitude || ""]:null),
            (items.some(i => i.type === "latlng")?
            ["longitude", itemChecked.longitude || ""]:null)
            ])));
            
        if(!picData.length){
            window.alert("Please sign!");
            return; 
        }
        const formData = new MyFormData();
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:""
        }))));
        formData.append("submitTime", (new MyDate()).ss());
        formData.append("signData", JSON.stringify(picData));
        formData.append("sign", document.getElementById("esign").toDataURL());
        //---------------------------------------------------------
        formData.append("data", JSON.stringify(curFormContent));
        formData.append("formContent", JSON.stringify(itemChecked));
        //---------------------------------------------------------
        formData.append("title", form.form.toUpperCase());
        formData.append("form", "preChecklist");
        formData.append("formHashKey", form.hashKey);
        formData.append("action", "Save");
        const docNum = itemChecked["Manhole No."]?itemChecked["Manhole No."]:
        (itemChecked["EP No."]?itemChecked["EP No."]:"");
        formData.append("docNum", docNum);
        formData.append("cancel", itemChecked.Cancel);
        formData.append("forms", "yes");
        //---------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("workLogs/forms.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, forms:(
                w.workLogHashKey === workLogHashKey?
                JSON.stringify(vehicleFormRes.data):
                w.forms
            )
        })));
        closeIt();
    }
    //---------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            if(isDevMode) console.log("useEffect");
            const formData = new MyFormData();
            formData.append("workLogHashKey", workLogHashKey);
            formData.append("formHashKey", form.hashKey);
            formData.append("action", "Read");
            //---------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("workLogs/forms.php", formData);
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------
            if(!isMounted) return;
            setPicData(JSON.parse(res.data.sign && (res.data.sign.indexOf("error") === -1)?res.data.sign:"[]")||[]);
            const sketches = JSON.parse(res.data.sketches && (res.data.sketches.indexOf("error") === -1)?res.data.sketches:"[]") || [];
            sketches.forEach(e => {
                if(e.sketchBgImg){
                    const img = new Image();
                    img.src = e.sketchBgImg[0];
                    e.sketchBgImg[0] = img; 
                }
            })
            setSketches(sketches||[]);
        }
        getData();
        return () => {isMounted = false;}
    },[workLogHashKey, form.hashKey, setPicData, setSketches]);
    //---------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {form.form.toUpperCase()}
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {handleFormSubmit}
            actionKey = "Submit"
            onSave = {handleFormSave}
        >
            <div>
                <div className = "blk5 my-2" style = {{display: "flex", alignItems: "center"}}>  
                    <label className = "font-weight-bold mr-3">Manhole No.</label>
                    <input
                        type = "text"
                        className = "form-control"
                        required
                        name = "Manhole No."
                        value = {itemChecked["Manhole No."]}
                        onChange = {e => {
                            setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                        }}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "font-weight-bold mr-3">Cancel</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {"CancelYes"}
                        name = {"Cancel"}
                        checked = {(itemChecked["Cancel"] === "Yes")}
                        value = {`Yes`}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                        className = "mr-2"
                        style = {{
                            width: 28, 
                            height: 28, 
                            verticalAlign: "middle", 
                            flexShrink: 0
                        }}
                    />
                    <label htmlFor = {"CancelYes"} className = "mr-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {"CancelNo"}
                        name = {"Cancel"}
                        checked = {(itemChecked["Cancel"] === "No")}
                        value = {`No`}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                        className = "mr-2"
                        style = {{
                            width: 28, 
                            height: 28, 
                            verticalAlign: "middle", 
                            flexShrink: 0
                        }}
                    />
                    <label htmlFor = {"CancelNo"}>No</label>
                </div>
                {itemChecked.Cancel === "No"?<>
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "font-weight-bold mr-3">Latitude:</label>
                    <input
                        type = "number"
                        step = "any"
                        className = "form-control mr-3"
                        required = {itemChecked.longitude}
                        name = "latitude"
                        value = {itemChecked.latitude || ""}
                        onChange = {e => {
                            setItemChecked({...itemChecked, latitude:e.currentTarget.value, 
                                Coordniates:
                                e.currentTarget.value && itemChecked.longitude?
                                `${e.currentTarget.value}, ${itemChecked.longitude}`:""});
                        }}
                    />
                    <label className = "font-weight-bold mr-3">Longitude:</label>
                    <input
                        type = "number"
                        step = "any" 
                        className = "form-control mr-3"
                        required = {itemChecked.latitude}
                        name = "longitude"
                        value = {itemChecked.longitude || ""}
                        onChange = {e => {
                            setItemChecked({...itemChecked, longitude:e.currentTarget.value, 
                                Coordniates:
                                e.currentTarget.value && itemChecked.latitude?
                                `${itemChecked.latitude}, ${e.currentTarget.value}`:""});
                        }}
                    />
                    <div style = {{display: "flex", alignItems: "center"}}>
                        <span className = "btn btn-primary mr-2"
                        onClick = {() => {
                            if(navigator.geolocation){
                                navigator.geolocation.getCurrentPosition(pos => {
                                    setItemChecked({...itemChecked, latitude:pos.coords.latitude, longitude:pos.coords.longitude, 
                                        Coordniates:`${pos.coords.latitude}, ${pos.coords.longitude}`});
                                }, error => alert(error.message), {enableHighAccuracy: true, timeout: 15000});
                            }else{
                                setItemChecked({...itemChecked, latitude:"", longitude:"", Coordniates: ""});
                            }
                        }}>
                            Get Location
                        </span>
                        <label>(GIS Grade)</label>
                    </div>
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>  
                    <label className = "font-weight-bold mr-3">Type</label>
                    <input
                        type = "text"
                        placeholder = "Sewer / Storm"
                        className = "form-control"
                        required
                        name = "Type"
                        value = {itemChecked["Type"]}
                        onChange = {e => {
                            setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                        }}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Material Type</label>
                    <input
                        type = "text"
                        className = "form-control"
                        required
                        name = "Material Type"
                        value = {itemChecked["Material Type"]}
                        onChange = {e => {
                            setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                        }}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Location</label>
                    <input
                        type = "text"
                        placeholder = {"Cross streets"}
                        className = "form-control"
                        required
                        name = "Location"
                        value = {itemChecked["Location"]}
                        onChange = {e => {
                            setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                        }}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Depth to Bottom</label>
                    <div style = {{display: "flex", alignItems: "center"}}>
                        <input
                            type = "number"
                            step = "any"
                            placeholder = {"Bottom of Manhole"} 
                            className = "form-control mr-2"
                            required
                            name = "Depth to Bottom" 
                            value = {itemChecked["Depth to Bottom"]}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        />
                        <label>inches</label>
                    </div>
                </div>
                {Array.from({length: itemChecked.inverts}).map((v, i) => 
                <div key = {i} className = "mb-2 p-2 border rounded">
                    <div className = "blk5 mb-2" style = {{display: "flex"}}>
                        <label className = "font-weight-bold mr-3">Invert {i + 1} Size</label>
                        {!itemChecked[`Invert ${i + 1} Size NA`]?
                        <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                            <input
                                type = "number"
                                step = "any"
                                placeholder = {"Pipe Size"}
                                className = "form-control mr-2"
                                required   
                                name = {`Invert ${i + 1} Size`}
                                value = {itemChecked[`Invert ${i + 1} Size`] || ""}
                                onChange = {e => {
                                    setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                                }}
                            />
                            <label className = "mr-3">inches</label>
                        </div>:null}
                        <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                            <input
                                type = "checkbox"
                                className = "mr-2"
                                style = {{width: 30, height: 30}}
                                name = {`Invert ${i + 1} Size NA`}
                                checked = {itemChecked[`Invert ${i + 1} Size NA`]}
                                onChange = {e => {
                                    setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.checked});
                                }}
                            />
                            <label>Unavailable</label>
                        </div>
                    </div>
                    <div className = "blk5 mb-2" style = {{display: "flex"}}>
                        <label className = "font-weight-bold mr-3">Invert  {i + 1} Depth</label>
                        {!itemChecked[`Invert ${i + 1} Depth NA`]?<>
                        <select
                            className = "form-control mr-3 mb-2"
                            required
                            name = {`Invert ${i + 1} topBottom`} 
                            value = {itemChecked[`Invert ${i + 1} topBottom`] || ""}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        >
                            <option value = "">Select</option>
                            <option>to bottom</option>
                            <option>to top</option>
                        </select>
                        <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                            <input
                                type = "number"
                                step = "any"
                                placeholder = {"Pipe Depth"} 
                                className = "form-control mr-2"
                                required 
                                name = {`Invert ${i + 1} Depth`} 
                                value = {itemChecked[`Invert ${i + 1} Depth`] || ""}
                                onChange = {e => {
                                    setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                                }}
                            />
                            <label className = "mr-3">inches</label>
                        </div>
                        </>:null}
                        <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                            <input
                                type = "checkbox"
                                className = "mr-2"
                                style = {{width: 30, height: 30}}
                                name = {`Invert ${i + 1} Depth NA`}
                                checked = {itemChecked[`Invert ${i + 1} Depth NA`]}
                                onChange = {e => {
                                    setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.checked});
                                }}
                            />Unavailable
                        </div>
                    </div>
                    <div className = "blk5 mb-2" style = {{display: "flex"}}>
                        <label className = "font-weight-bold mr-3">Invert {i + 1} Direction</label>
                        <select
                            className = "form-control"
                            required
                            name = {`Invert ${i + 1} Direction`} 
                            value = {itemChecked[`Invert ${i + 1} Direction`] || ""}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        >
                            <option value = "">Select</option>
                            <option value = "South">S</option>
                            <option value = "North">N</option>
                            <option value = "East">E</option>
                            <option value = "West">W</option>
                            <option value = "South West">SW</option>
                            <option value = "North West">NW</option>
                            <option value = "South East">SE</option>
                            <option value = "North East">NE</option>
                            <option value = "South to North">S to N</option>
                            <option value = "SouthWest to NorthEast">SW to NE</option>
                            <option value = "West to East">W to E</option>
                            <option value = "NorthWest to SouthEast">NW to SE</option>
                            <option value = "North to South">N to S</option>
                            <option value = "NorthEast to SouthWest">NE to SW</option>
                            <option value = "East to West">E to W</option>
                            <option value = "SouthEast to NorthWest">SE to NW</option>
                            <option>Unavailable</option>
                        </select>                  
                    </div>
                </div>)}
                <div className = "mb-2">
                    <span className = "btn btn-primary mr-3" onClick = {() => {setItemChecked({...itemChecked, inverts: (itemChecked.inverts) + 1})}}>Add Invert</span>
                    {itemChecked.inverts?
                    <span className = "btn btn-danger ml-3" onClick = {() => {
                        setItemChecked({...itemChecked, 
                            [`Invert ${itemChecked.inverts} Size`]:"",
                            [`Invert ${itemChecked.inverts} Depth`]:"",
                            [`Invert ${itemChecked.inverts} Direction`]:"",
                        })
                        setItemChecked({...itemChecked, inverts: itemChecked.inverts - 1});
                    }}>Delete Invert</span>:null}
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 1</label>
                    <span>
                        <input
                            type = "text"
                            className = "form-control"
                            required
                            name = "Swing Tie 1"
                            value = {itemChecked["Swing Tie 1"]}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        />
                    </span>
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 2</label>
                    <span>
                        <input
                            type = "text"
                            className = "form-control"
                            required
                            name = "Swing Tie 2"
                            value = {itemChecked["Swing Tie 2"]}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        />
                    </span>
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 3</label>
                    <span>
                        <input
                            type = "text"
                            className = "form-control"
                            required
                            name = "Swing Tie 3"
                            value = {itemChecked["Swing Tie 3"]}
                            onChange = {e => {
                                setItemChecked({...itemChecked, [e.currentTarget.name]: e.currentTarget.value});
                            }}
                        />
                    </span>
                </div>
                </>:null}
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3">Notes</label>
                    <textarea
                        rows = {6}
                        className = "form-control w-100"
                        required
                        name = {"Notes"}
                        value = {itemChecked["Notes"] || ""}
                        onChange = {e => {
                            setItemChecked({...itemChecked, [e.currentTarget.name]:e.currentTarget.value});
                        }}
                    />
                </div>
            </div>
            {form.form === "Manhole Form"?
            <Sketch 
                mainClassName = "mb-2"
                buttonClasName = "my-2"
                sketches = {sketches} 
                setSketches = {setSketches}
                limit = {0}
                showSketch = {showSketch}
                setShowSketch = {setShowSketch}
            />:null}
            <div className = "blk5 mb-2" style = {{display: "flex"}}>
                <label className = "required-field mr-3">Member name:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "memberName"
                    value = {userName || user.userName}
                />
                <label className = "required-field mr-3">Date:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "submitDate"
                    value = {(new MyDate()).s()}
                />
            </div>
            <Esign
                buttonClassName = "my-2"
                picData = {picData}
                setPicData = {setPicData}
            />
        </Modal>
    )    
}